import styled from "styled-components"
import type { TableWrapperProps } from "./types"

export const Table = styled.table<TableWrapperProps>`
  box-sizing: border-box;
  border-collapse: collapse;
  border-radius: ${(props) => props.borderRadius ?? "5px"};

  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  max-width: ${(props) => props.maxWidth};

  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  word-break: ${(props) => props.wordBreak};

  overflow: ${(props) => props.overflow};
  overflow-x: ${(props) => props.overflowX};
  overflow-y: ${(props) => props.overflowY};

  /* Necessary for keeping border-radius after we use border-collapse method
   since tables are weird */

  tr:last-child td:first-child {
    border-bottom-left-radius: 5px;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 5px;
  }

  thead th:first-child {
    border-top-left-radius: 5px;
  }

  thead th:last-child {
    border-top-right-radius: 5px;
  }
`

Table.defaultProps = {
  fullWidth: false,
  maxWidth: "auto",

  fontSize: "14px",
  wordBreak: "normal",

  overflow: "visible",
  overflowX: "visible",
  overflowY: "visible",
}
